import type { Contact, ContactDto } from "~/types/api";
import type { ApiResponse } from "~/types/ui";
import { BaseAPI } from "./base";

export class ContactApi extends BaseAPI {
  async getContacts(): Promise<ApiResponse<Contact[]>> {
    return this.get<Contact[]>(`contact/${this.company()}`);
  }
  async createContact(payload: ContactDto): Promise<ApiResponse<Contact>> {
    return this.post<Contact>(`contact/${this.company()}`, payload);
  }
  async createContacts(payload: ContactDto[]): Promise<ApiResponse<Contact[]>> {
    return this.post<Contact[]>(`contact/bulk/${this.company()}`, payload);
  }
  async deleteContact(contactId: string): Promise<ApiResponse<void>> {
    return this.delete<void>(`contact/${contactId}`);
  }
}
